module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Linda Howard\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Linda Howard is "), _c('I', [_vm._v("the")]), _vm._v(" "), _c('I', [_vm._v("New York Times")]), _vm._v("–bestselling romance and suspense author of "), _c('I', [_vm._v("Up Close")]), _vm._v(" "), _c('I', [_vm._v("and")]), _vm._v(" "), _c('I', [_vm._v("Dangerous")]), _vm._v(", "), _c('I', [_vm._v("Drop Dead Gorgeous")]), _vm._v(", "), _c('I', [_vm._v("Cover of Night")]), _vm._v(", "), _c('I', [_vm._v("Killing Time")]), _vm._v(", "), _c('I', [_vm._v("To Die For")]), _vm._v(", "), _c('I', [_vm._v("Kiss Me While I Sleep")]), _vm._v(", "), _c('I', [_vm._v("Cry No More")]), _vm._v(", and "), _c('I', [_vm._v("Dying to Please")]), _vm._v(". She is a charter member of Romance Writers of America and in 2005 was awarded their Lifetime Achievement Award. Howard lives in Gadsden, Alabama, with her husband and two golden retrievers. She has three grown stepchildren and three grandchildren."), _c('BR'), _vm._v("  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/12S2PwJ/tc-custom/9781504087759.jpg?1705317486495",
      "alt": "This image is the cover for the book All that Glitters"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("All that Glitters\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("From a "), _c('i', [_vm._v("New York Times")]), _vm._v("–bestselling author, a classic romance about enemies who become lovers and battle their way into each other’s hearts.")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Rumors swirled around Jessica Stanton. That the young widow had only married her husband to get her hands on the older man’s fortune. That she’s as cunning as she is beautiful. But that doesn’t stop Greek billionaire Nikolas Constantinos from wanting her the moment he lays eyes on her. Despite the adversarial business deal that brought them together. Despite her scandalous past. Because as it turns out, there’s only one thing the powerful tycoon can’t control: his passion for the woman who may be his undoing.\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0